// TagFilter.js
import './TagFilter.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { MultiSelectDropdown, SecondaryButton, useSessionStorage, useOutsideClick } from 'ui_kit_qmd'
import { memo, useCallback, useEffect, useState } from 'react'
import {
  CLEAR_TEXT,
  TAGS_FILTER_DROPDOWN_LABEL,
  VISITS_TAGS_FILTER_LOCAL_STORAGE_KEY,
} from '../../../../utils/constants'

const generateTagsOptionsList = () => [
  { value: '1st', id: 'IsNewForServiceType', type: 'flag', isActive: false },
  { value: 'New', id: 'IsNewForPatient', type: 'flag', isActive: false },

  // Drug Screen Statuses
  { value: 'Drug screen verified', id: 'verified', type: 'drugScreen', isActive: false },
  { value: 'Prior drug screen, revalidate', id: 'legacyunverified', type: 'drugScreen', isActive: false },
  {
    value: 'Patient changed state, revalidate',
    id: 'addressunverified',
    type: 'drugScreen',
    isActive: false,
  },
  { value: 'Drug screen expired', id: 'expired', type: 'drugScreen', isActive: false },
  { value: 'No drug screen on file', id: 'due', type: 'drugScreen', isActive: false },
  { value: 'Drug screen due soon', id: 'duesoon', type: 'drugScreen', isActive: false },
  { value: 'Drug screen exempt', id: 'exempt', type: 'drugScreen', isActive: false },

  // Identity Verification Statuses
  { value: 'ID not verified', id: 'unverified', type: 'identityVerification', isActive: false },
  { value: 'ID request sent', id: 'requested', type: 'identityVerification', isActive: false },
  {
    value: 'ID legacy verified',
    id: 'legacyverified',
    type: 'identityVerification',
    isActive: false,
  },
  {
    value: 'ID manually verified',
    id: 'manuallyverified',
    type: 'identityVerification',
    isActive: false,
  },
  { value: 'ID verified', id: 'verified', type: 'identityVerification', isActive: false },
  { value: 'ID warning', id: 'warning', type: 'identityVerification', isActive: false },
  { value: 'ID failed', id: 'failed', type: 'identityVerification', isActive: false },
]

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const TagFilter = memo(({ onCloseFilterSettings, setFilterRow, loading }) => {
  const ref = useOutsideClick(onCloseFilterSettings)
  const [tagOptions, setTagOptions] = useState([])
  const [storedTagOptions, setStoredTagOptions, removeStoredTagOptions] = useSessionStorage(
    VISITS_TAGS_FILTER_LOCAL_STORAGE_KEY,
    [],
  )

  useEffect(() => {
    // Check if session storage is empty and initialize from generateTagsOptionsList if necessary
    const options = storedTagOptions.length ? storedTagOptions : generateTagsOptionsList()

    // Debugging: Log both stored options and final options to check for issues
    console.log('Stored Tag Options from Session Storage:', storedTagOptions)
    console.log('Initialized Tag Options:', options)

    setTagOptions(options)

    // If session storage was empty, populate it with the full list
    if (!storedTagOptions.length) {
      setStoredTagOptions(options)
    }
  }, [storedTagOptions, setStoredTagOptions])

  const onSetTagOptions = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (newOptions) => {
      setTagOptions(newOptions)
      setStoredTagOptions(newOptions)

      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const selectedOptions = newOptions.filter((option) => option.isActive)

      // Extract individual flags and statuses
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const isNewForPatient = selectedOptions.some((option) => option.id === 'IsNewForPatient')
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const isNewForServiceType = selectedOptions.some((option) => option.id === 'IsNewForServiceType')
      const drugScreenStatuses = selectedOptions
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .filter((option) => option.type === 'drugScreen')
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((option) => option.id)
      const identityVerificationStatuses = selectedOptions
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .filter((option) => option.type === 'identityVerification')
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((option) => option.id)

      // Construct parameters in the desired array format
      const drugScreenParams = drugScreenStatuses
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((status, index) => `DrugScreenStatuses[${index}]=${status}`)
        .join('&')
      const identityVerificationParams = identityVerificationStatuses
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        .map((status, index) => `IdentityVerificationStatuses[${index}]=${status}`)
        .join('&')

      // Build query string for API
      const apiRequestRow = [
        isNewForPatient && `IsNewForPatient=true`,
        isNewForServiceType && `IsNewForServiceType=true`,
        drugScreenParams,
        identityVerificationParams,
      ]
        .filter(Boolean) // Remove any empty items
        .join('&')

      // Debugging: Log final apiRequestRow to confirm correct construction
      console.log('apiRequestRow:', apiRequestRow)

      setFilterRow(apiRequestRow)
    },
    [setFilterRow, setStoredTagOptions],
  )
  const onClearFilter = useCallback(() => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setTagOptions((prev) => prev.map((t) => ({ ...t, isActive: false })))
    setFilterRow('')
    removeStoredTagOptions()
  }, [removeStoredTagOptions, setFilterRow])

  return (
    <div className='tags-filter-container' ref={ref}>
      <MultiSelectDropdown
        isWithOptionsSort
        isDisabled={loading}
        isFlexible
        isEmptyMessage
        options={tagOptions}
        setOptions={onSetTagOptions}
        className='tags-filter-dropdown'
        dropId='tags-filter-dropdown-id'
        label={TAGS_FILTER_DROPDOWN_LABEL}
      />
      <SecondaryButton
        btnText={CLEAR_TEXT}
        onPress={onClearFilter}
        id='clear-tags-options-btn'
        className='clear-tags-options-btn-container'
      />
    </div>
  )
})

export default TagFilter
